import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { useStore } from "zustand";
import { accountStore } from "entities/account";
import { PATH_LIST } from "shared/lib/react-router";
import Loading from "widgets/loading";
import RepoTransactionField from "../components/repo-transaction-field";
import { RepoTransactionFilter } from "../components/repo-transaction-filter/index";
import GoBack from "../../../assets/GoBackApp.svg";
import Filter from "../../../assets/FilterIcon.svg";
import "./style.scss";

export const RepoTransactionHistory: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation("app");
  const {
    isLoading,
    depositPayments,
    depositPaymentsCount,
    getDepositPayments,
  } = useStore(accountStore);
  const [filterOpened, setFilterOpened] = useState(false);
  const [filter, setFilter] = useState<{
    currency?: string[];
    amount?: number[];
    fromDate?: string | null;
    toDate?: string | null;
  }>({});

  useEffect(() => {
    getDepositPayments();
  }, []);

  const filteredTransactions = depositPayments.filter((item) => {
    if (!item.paid) return false;

    // Currency
    if (
      filter.currency?.length &&
      !filter.currency
        .map((c) => c.toUpperCase())
        .includes(item.currency.toUpperCase())
    ) {
      return false;
    }

    // Amount
    if (
      filter.amount &&
      (item.fix_amount < filter.amount[0] || item.fix_amount > filter.amount[1])
    ) {
      return false;
    }

    // Date
    if (
      (filter.fromDate &&
        moment(item.start_date).isBefore(
          moment(filter.fromDate, "YYYY.MM.DD")
        )) ||
      (filter.toDate &&
        moment(item.end_date).isAfter(moment(filter.toDate, "YYYY.MM.DD")))
    ) {
      return false;
    }

    return true;
  });

  if (isLoading || !depositPaymentsCount) {
    return <Loading />;
  }

  return (
    <div className="repo-transaction-history-page">
      <div
        className={
          !filterOpened && filter.currency
            ? "repo-transaction-header repo-transaction-filter-tag"
            : "repo-transaction-header"
        }
      >
        <img
          className="go-back-repo-transaction"
          onClick={() => navigate(PATH_LIST.repoTransaction)}
          src={GoBack}
          alt="Go Back"
        />
        <p>{t("history")}</p>
        <img
          className="repo-transaction-filter"
          onClick={() => {
            setFilterOpened(!filterOpened);
          }}
          src={Filter}
          alt="history"
        />
      </div>

      <RepoTransactionFilter
        opened={filterOpened}
        onClose={() => setFilterOpened(false)}
        onConfirm={(newFilter) => {
          setFilter({
            currency: newFilter.currency,
            amount: newFilter.amount,
            fromDate: newFilter.fromDate,
            toDate: newFilter.toDate,
          });
          setFilterOpened(false);
        }}
        onReset={() => {
          setFilter({});
        }}
      />

      <div className="repo-transaction-main">
        {filteredTransactions.length === 0 ? (
          <p style={{ fontSize: "16px", marginTop: "30px" }}>
            {t("noTransactionsFound")}
          </p>
        ) : (
          filteredTransactions.map((item, index) => (
            <RepoTransactionField
              key={index}
              type="deposit-payment"
              data={item}
            />
          ))
        )}
      </div>
    </div>
  );
};
